import React from 'react';

export const MaterialContext = React.createContext({});
